import { Roles } from "../../types";
import { validateEmailAddress } from "../email-validation";

export class AuthValidation {
    static validateEmail(email: string): string | null {
        return validateEmailAddress(email);
    }

    static validatePassword(password: string): string | null {
        if (!password) {
            return "Password is required";
        }
        if (password.length < 6) {
            return "Password is too short";
        }
        return null;
    }

    static roleValidation(role: string): string | null {
        if (!role) {
            return "Role is required";
        }
        if (!Object.values(Roles).includes(role as Roles)) {
            return "Role is invalid";
        }
        return null
    }

    static validateAgree(agree: boolean): string | null {
        if (!agree) {
            return "You must agree to the terms and conditions";
        }
        return null;
    }
}
